import React, { useState, useEffect, useCallback } from "react";
import appStyle from "./AIAgentBot.module.css";
import AIMessageCredits from "./AIMessageCredits";
import IngestionStorage from "./IngestionStorage";
import SiteUsers from "./SiteUsers";
import { useTenantPlan } from "../../hooks/useTenantPlan";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export default function LimitsAndTopUp({ tenantPlan, fullTenantData }) {
  const {
    data: tenantPlanData,
    loading: planLoading,
    error: planError,
  } = useTenantPlan();

  const effectiveData = tenantPlanData || fullTenantData;
  // AI Message Credits
  const aiMessageLimit = effectiveData?.aimm_limit || 0;
  const aiMessagesRemaining = effectiveData?.global_ai_msgs_remaining || 0;
  const totalAiTopups = effectiveData?.total_topups_ai_messages || 0;
  const isLoadingAiLimit = planLoading;

  // Ingestion Storage
  const ingestionLimit = effectiveData?.max_ingest_limit || 0;
  const ingestionRemaining = effectiveData?.global_ingest_size_remaining || 0;
  const totalIngestionTopups = effectiveData?.total_topups_ingestion || 0;
  const isLoadingIngestionLimit = planLoading;

  // Site Users
  const siteUsersLimit = effectiveData?.msu_limit || 0;
  const siteUsersRemaining = effectiveData?.global_site_users_remaining || 0;
  const totalSiteUsersTopups = effectiveData?.total_topups_site_users || 0;
  const isLoadingSiteUsersLimit = planLoading;

  if (planError) {
    console.warn("Error loading tenant plan:", planError);
  }

  return (
    <>
      <AIMessageCredits
        limit={aiMessageLimit}
        remaining={aiMessagesRemaining}
        totalTopups={totalAiTopups}
        isLoading={isLoadingAiLimit}
      />

      <IngestionStorage
        limit={ingestionLimit}
        remaining={ingestionRemaining}
        totalTopups={totalIngestionTopups}
        isLoading={isLoadingIngestionLimit}
      />

      <SiteUsers
        limit={siteUsersLimit}
        remaining={siteUsersRemaining}
        totalTopups={totalSiteUsersTopups}
        isLoading={isLoadingSiteUsersLimit}
      />
    </>
  );
}
